interface CheckFilledProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const CheckFilled = ({ className = '', ...props }: CheckFilledProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M8.99991 16.1701L4.82991 12.0001L3.40991 13.4101L8.99991 19.0001L20.9999 7.00009L19.5899 5.59009L8.99991 16.1701Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CheckFilled;
